<template>
  <div class="animated fadeIn">
    <div>
      <b-row>
        <b-col cols="12">
            <h1>Global System Settings</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header">
                <strong>Current Settings</strong>
            </div>
            <div v-if="!settingsLoaded" class="form-container">
                <LoadingSpinner />
            </div>
            <div v-if="settingsLoaded" class="form-container">
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="desktopTimeout">{{desktopTimeout.desc}}</label>
                    <b-form-input v-model="desktopTimeout.value" type="text" id="desktopTimeout"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="bsauNumber">{{bsauNumber.desc}}</label>
                    <b-form-input v-model="bsauNumber.value" type="text" id="bsauNumber"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="sapSupportPhone">{{sapSupportPhone.desc}}</label>
                    <b-form-input v-model="sapSupportPhone.value" type="text" id="sapSupportPhone"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="sapSupportEmail">{{sapSupportEmail.desc}}</label>
                    <b-form-input v-model="sapSupportEmail.value" type="text" id="sapSupportEmail"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="12" sm="12" md="12">
                  <p class="action-button-toolbar">
                  <b-button
                      v-on:click="updateSettings"
                      variant="primary"
                      :disabled="saveInProgress"
                  >
                      <i class="fa fa-check"></i>&nbsp;Update Settings
                  </b-button>
                  </p>
                  <b-alert v-if="saveSuccess" variant="success" show>
                    <strong>Data saved successfully.</strong>
                  </b-alert>
                  <b-alert v-if="saveError" variant="danger" show>
                    <strong>Error saving data. Please try again.</strong>
                  </b-alert>
                  <b-alert v-if="saveInProgress" variant="info" show>
                    <strong>Saving data. Please wait...</strong>
                  </b-alert>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header">
              <strong>Other Sections</strong>
            </div>
            <div class="form-container">
              <b-row>
                <b-col cols="12" sm="6" md="6">
                  <b-card footer-class="px-3 py-2">
                    <b-card-body class="p-3 clearfix">
                      <i class="bg-success fa fa-cog p-3 font-2xl mr-3 float-left"></i>
                      <div class="h5 text-warning mb-0">Eire Index Mark Codes</div>
                      <div class="text-muted text-uppercase font-weight-bold font-xs">Manage the Eire Index Mark Codes for Irish Plates </div>
                    </b-card-body>
                    <div slot="footer">
                      <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/settings/eire-index-marks'">Go <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                    </div>
                  </b-card>
                </b-col>
                <b-col cols="12" sm="6" md="6">
                  <b-card footer-class="px-3 py-2">
                    <b-card-body class="p-3 clearfix">
                      <i class="bg-success fa fa-font p-3 font-2xl mr-3 float-left"></i>
                      <div class="h5 text-warning mb-0">System Fonts</div>
                      <div class="text-muted text-uppercase font-weight-bold font-xs">Manage the system fonts for the desktop software </div>
                    </b-card-body>
                    <div slot="footer">
                      <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/settings/system-fonts'">Go <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "../../components/loadingSpinner/LoadingSpinner";

const getHTTPHeaders = () => {
  let userObj = JSON.parse(localStorage.getItem("user"));
  let headerConfig = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Authorization": "Bearer " + userObj.token,
    }
  };
  return headerConfig;
};

const getSettingsData = $http => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
    $http
      .get("settings", headersObj)
      .then(response => {
        resolve(response.data.settings);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
};

export default {
  name: "settings",
  components: {
    LoadingSpinner: LoadingSpinner,
  },
  data() {
    return {
      desktopTimeout: {},
      bsauNumber: {},
      sapSupportPhone: {},
      sapSupportEmail: {},
      settingsLoaded: false,
      saveSuccess: false,
      saveError: false,
      saveInProgress: false,
      isFirstEntry: true,
    };
  },
  created() {
    // grab the settings
    this.getSettings();
  },
  methods: {
    getSettings() {
      getSettingsData(this.$http).then(data => {
        console.log(data);
        this.$data.settings = data.map(settingItem => {
          let settingObj = {
            id: settingItem.id,
            desc: settingItem.setting_description,
            value: settingItem.setting_value
          };
          switch (settingItem.setting_name) {
            case "DESKTOP_TIMEOUT": {
              this.$data.desktopTimeout = settingObj;
              break;
            }
            case "BSAU_NUMBER": {
              this.$data.bsauNumber = settingObj;
              break;
            }
            case "SAP_SUPPORT_PHONE": {
              this.$data.sapSupportPhone = settingObj;
              break;
            }
            case "SAP_SUPPORT_EMAIL": {
              this.$data.sapSupportEmail = settingObj;
              break;
            }
            default: {
              //this.$data.desktopTimeout = {'desc': settingItem.setting_description};
              break;
            }
          }
        });
        this.$data.settingsLoaded = true;
      });
    },
    clearAlerts() {
      this.$data.saveSuccess = false;
      this.$data.saveError = false;
      this.$data.saveInProgress = false;
    },
    updateSettings() {
      this.clearAlerts();
      this.$data.saveInProgress = true;
      // get headers first
      let headersObj = getHTTPHeaders();

      // Send each setting to the backend
      let desktopTimeoutSettingsObj = {
        id: parseInt(this.$data.desktopTimeout.id),
        setting_value: this.$data.desktopTimeout.value
      };

      let bsauNumberSettingsObj = {
        id: parseInt(this.$data.bsauNumber.id),
        setting_value: this.$data.bsauNumber.value
      };

      let sapSupportPhoneSettingsObj = {
        id: parseInt(this.$data.sapSupportPhone.id),
        setting_value: this.$data.sapSupportPhone.value
      };

      let sapSupportEmailSettingsObj = {
        id: parseInt(this.$data.sapSupportEmail.id),
        setting_value: this.$data.sapSupportEmail.value
      };

      // Save the data with the chaining effect
      this.$http
        .put("setting", desktopTimeoutSettingsObj, headersObj)
        .then(response => {
          this.$data.saveError = false;
          if (false === response.data.success) {
            this.$data.saveError = true;
          } else {
            return this.$http.put(
              "setting",
              bsauNumberSettingsObj,
              headersObj
            );
          }
        })
        .then(response => {
          if (false === response.data.success) {
            this.$data.saveError = true;
          } else {
            return this.$http.put(
              "setting",
              sapSupportPhoneSettingsObj,
              headersObj
            );
          }
        })
        .then(response => {
          if (false === response.data.success) {
            this.$data.saveError = true;
          } else {
            return this.$http.put(
              "setting",
              sapSupportEmailSettingsObj,
              headersObj
            );
          }
        })
        .then(response => {
          if (false === response.data.success) {
            this.$data.saveError = true;
          } else {
            this.$data.saveInProgress = false;
            this.$data.saveSuccess = true;
            this.$data.saveError = false;
          }
        })
        .catch(err => {
          console.error(err);
          this.$data.saveInProgress = false;
          this.$data.saveSuccess = false;
          this.$data.saveError = true;
        });
    },
  }
};
</script>
